import React from 'react';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { isFreeTrial } from 'helpers/userHelper';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';
import { useEventHandler } from 'hook/event.hook';
import { useHistory } from 'react-router-dom';
import { PREMIUM_FEATURE_CREDIT_REPORT } from 'types/premium.constants';
import { useSubscriptionLandingUrl } from 'hook/subscriptionLandingUrl.hook';

const FactorAddDataButton = props => {
  const { linkClassName } = props;
  const { userInfo, selectedFactor, config } = useSelector(state => ({
    userInfo: state?.userInfo?.userInfo,
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
    config: state?.config?.config,
  }));
  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();
  const eventHandler = useEventHandler();
  const history = useHistory();

  const redirectPath = isFreeTrial(userInfo)
    ? '/creditReports/view?nav=premiumCreditReports&modal=TRIAL'
    : subscriptionLandingUrl + '?feature=' + PREMIUM_FEATURE_CREDIT_REPORT;

  const onClick = () => {
    eventHandler(CLICK, {
      'Click Type': 'Update To Premium View Pop Up',
      'Module Name': 'Grade Dial 3B - ' + factorMapping?.get(selectedFactor),
      Vertical: SUBSCRIPTION_VERTICAL,
    });

    history.push(redirectPath);
  };

  return (
    <FlexContainer
      className={classnames(
        'router-link bgGray005 border-rad8px justify-center pointer height100',
        linkClassName,
      )}
      onClick={onClick}
    >
      <FlexContainer
        className={'items-align-center flex-column justify-center padtb10'}
      >
        <Image className={'plusIconBrand width10px height10px margB2'} />
        <Label
          type="Lato-Bold"
          className={'bold margt2 text-8 primary_text_light'}
        >
          {config?.dashboardStyle?.creditFactor?.addDataButtonLabel}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default FactorAddDataButton;
